const PDF_STATUS_POLL_INTERVAL_MS = 2000;
const PDF_STATUS_MAX_POLLS = 60;

function showProcessingTimeout(messageEl) {
  if (!messageEl) return;
  messageEl.innerHTML =
    '<i class="fas fa-exclamation-triangle"></i> Processing is taking longer than expected. Please refresh the page manually.';
  messageEl.classList.remove('alert-info');
  messageEl.classList.add('alert-warning');
}

export function pollPdfStatus(statusUrl, { messageEl, reloadOnComplete = true } = {}) {
  let pollCount = 0;
  window.pdfPollingActive = true;

  function complete() {
    window.pdfPollingActive = false;
    if (reloadOnComplete) {
      window.location.reload();
    }
  }

  function scheduleRetry(delayMs = PDF_STATUS_POLL_INTERVAL_MS) {
    if (pollCount < PDF_STATUS_MAX_POLLS) {
      pollCount++;
      setTimeout(checkStatus, delayMs);
    } else {
      window.pdfPollingActive = false;
      showProcessingTimeout(messageEl);
    }
  }

  function checkStatus() {
    fetch(statusUrl, {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    })
      .then((res) => {
        if (!res.ok) throw new Error(`[pdf_polling] HTTP ${res.status}`);
        return res.json();
      })
      .then((data) => {
        if (typeof data.processing_pdf !== 'boolean') {
          console.warn('[pdf_polling] Unexpected payload shape; retrying.', data);
          scheduleRetry();
          return;
        }

        if (!data.processing_pdf) {
          complete();
        } else {
          scheduleRetry();
        }
      })
      .catch((err) => {
        console.error('[pdf_polling] Status check failed:', err);
        scheduleRetry(3000);
      });
  }

  setTimeout(checkStatus, PDF_STATUS_POLL_INTERVAL_MS);
}

export function initPlansPdfStatusPolling() {
  const container = document.getElementById('pdf-preview-container');
  if (!container || container.dataset.pollPdfStatus !== 'true') return;
  if (window.pdfPollingActive) return;

  const statusUrl = container.dataset.pdfStatusUrl;
  if (!statusUrl) return;

  const messageEl = document.getElementById('processing-message');
  pollPdfStatus(statusUrl, { messageEl });
}
